import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface PlaceOrderInput {
    orderId: string;
    potentialTotal: boolean;
    preOrder: boolean;
    quotesOnly: boolean;
    oemEndorsement: boolean;
    allowAutoOrder: boolean;
    expedited: boolean;
    dealerReferral?: string;
    vendorMessage: string;
    resubmit?: boolean;
    scheduledArrivalDate?: string;
}

const requestQuotes = async (data: PlaceOrderInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/order/request-quotes`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useRequestQuotes = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (data: PlaceOrderInput) => requestQuotes(data, sessionContext?.sessionId ?? null),
        onError: (error) => {
            console.error('Failed to place order:', error);
        }
    });
};
